<form [formGroup]="form" novalidate autocomplete="off">
  <div class="modal-dialog-header">
    <button
      type="button"
      tabindex="-1"
      class="close float-right"
      data-dismiss="modal"
      aria-label="Close"
      (click)="cancel()"
      title="Close form and discard any changes."
    >
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
    <h3 mat-dialog-title>{{ data.title }}</h3>
  </div>
  <mat-dialog-content class="modal-dialog-content">
    <div class="form-row">
      <div class="form-group col-sm-4">
        <label for="name">Receiving Document Number</label>
        <input formControlName="number" class="form-control form-control-sm" />
        <p *ngIf="form.get('number').invalid && form.get('number').dirty" class="text-danger">
          A Receiving Document Number is required
        </p>
      </div>
      <div class="form-group col-sm-4">
        <label for="status">Status</label>
        <select formControlName="status" class="form-control form-control-sm">
          <option>Pending</option>
          <option>Received</option>
          <option>Cancelled</option>
        </select>
      </div>
      <div class="form-group col-sm-4">
        <label for="ripNumber">RIP</label>
        <select formControlName="ripNumber" class="form-control form-control-sm">
          <option *ngFor="let rip of data.rips" [ngValue]="rip.number">{{ rip.number }}</option>
        </select>
        <p *ngIf="form.get('ripNumber').invalid && form.get('ripNumber').dirty" class="text-danger">
          A RIP Number is required
        </p>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-sm-8">
        <label for="vendorId">Vendor</label>
        <a (click)="openNewVendorModal()" style="margin-top: 2px;" class="float-right small pointer text-primary"
          ><i class="far fa-plus"></i> New Vendor</a
        >
        <select formControlName="vendorId" class="form-control form-control-sm">
          <option *ngFor="let vendor of vendors$ | async" [ngValue]="vendor.id">{{ vendor.name }}</option>
        </select>
      </div>

      <div class="form-group col-sm-4">
        <label for="projectId">Project</label>
        <select formControlName="projectId" class="form-control form-control-sm">
          <option *ngFor="let project of data.projects" [ngValue]="project.id">{{ project.code }}</option>
        </select>
        <p *ngIf="form.get('projectId').invalid && form.get('projectId').dirty" class="text-danger">
          A Project is required
        </p>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-sm-4">
        <label for="orderDate">Order Date</label>
        <input formControlName="orderDate" type="date" class="form-control form-control-sm" />
      </div>
      <div class="form-group col-sm-4">
        <label for="shippingDate">Shipping Date</label>
        <input formControlName="shippingDate" type="date" class="form-control form-control-sm" />
      </div>
      <div class="form-group col-sm-4">
        <label for="deliveryDate">Delivery Date</label>
        <input formControlName="deliveryDate" type="date" class="form-control form-control-sm" />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-sm-6">
        <label for="name">Site</label>
        <select formControlName="siteId" class="form-control form-control-sm">
          <option *ngFor="let site of data.sites" [ngValue]="site.id">{{ site.name }}</option>
        </select>
        <p *ngIf="form.get('siteId').invalid && form.get('siteId').dirty" class="text-danger">
          An originating SMARTTRONIX Site is required
        </p>
      </div>
      <div class="form-group col-sm-6">
        <label for="trackingNumber">Tracking Number</label>
        <input formControlName="trackingNumber" type="text" class="form-control form-control-sm" />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-sm-12">
        <label for="vendorOrderNumber">Vendor Order Number</label>
        <input formControlName="vendorOrderNumber" type="text" class="form-control form-control-sm" />
      </div>
    </div>
    <div class="form-group">
      <label for="notes">Notes</label>
      <textarea autosize formControlName="notes" class="form-control form-control-sm"></textarea>
    </div>
  </mat-dialog-content>
  <div class="modal-dialog-footer">
    <button type="button" class="btn btn-default float-left btn-sm" (click)="cancel()">
      <fa-icon [icon]="faTimes"></fa-icon> Cancel
    </button>
    <button type="button" (submitIfValid)="save()" [form]="form" class="btn btn-primary float-right btn-sm">
      <fa-icon [icon]="faSave"></fa-icon> Save
    </button>
  </div>
</form>
